export enum DiscountTypeEnum {
    HasDiscount = 1,
    NoDiscount = 2,
}
  